import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Checkbox, Dropdown, Input, Select, Button, message, DatePicker, Tooltip, Spin } from "antd";
import {
  LeftOutlined,
  DeleteOutlined,
  HolderOutlined,
  CloseOutlined,
  FilePdfOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import SearchBlueIcon from "../../Assets/reportBuilder/search-blue.svg";
import SaveIcon from "../../Assets/reportBuilder/save-icon-new.svg";
import PreviewIcon from "../../Assets/reportBuilder/preview-icon-new.svg";
import DownloadIconWhite from "../../Assets/reportBuilder/download-icon-white.svg";
import DownloadIcon from "../../Assets/reportBuilder/download-icon.svg";
import ChevronDownWhiteIcon from "../../Assets/reportBuilder/chevron-down-white.svg";
import ChevronDownIcon from "../../Assets/reportBuilder/chevron-down.svg";
import PlusFilterIcon from "../../Assets/reportBuilder/plus-filter.svg";
import PdfColumnLimitModal, { PDF_COLUMN_LIMIT } from "./PdfColumnLimitModal";
import { formatPreviewDateValue, formatReportFieldLabel, formatLabelSpacing, compareAlphaLabels, matchesReportSearch, normalizeReportColumnIds } from "./formatFieldLabel";
import { showReportError } from "./reportToast";
import {
  getColumnKey,
  getExportColumnCount,
  getResponseColumnLabel,
  getResponseColumns,
  FIELD_EXPORT_COLUMN_MAP,
  readTotalRows,
  sliceFieldsToExportColumnLimit,
} from "./reportGenerateUtils";
import GatesPreviewCell, { isGatesPreviewField } from "./GatesPreviewCell";
import SuccessIcon from "../../Assets/campagin/success.svg";
import WarningIcon from "../../Assets/campagin/warning.svg";
import StopIcon from "../../Assets/campagin/stop.svg";
import API_MANAGER from "../../API";
import {
  ensureSocketConnected,
  requestReportDownload,
} from "../../components/Socket/socket";

const { RangePicker } = DatePicker;

const REPORT_TITLE_PLACEHOLDER = "Enter report name";

const FIELD_GROUPS = [
  {
    category: "Candidate Info",
    fields: [
      { id: "firstName", label: "First Name", badge: "Worker" },
      { id: "lastName", label: "Last Name", badge: "Worker" },
      { id: "candidateName", label: "Full Name", badge: "Worker" },
      { id: "email", label: "Email", badge: "Worker" },
      { id: "gender", label: "Gender", badge: "Worker" },
      { id: "ethnicity", label: "Ethnicity", badge: "Worker" },
      { id: "discipline", label: "Discipline", badge: "Worker" },
      { id: "availabilityDetails", label: "Notice Period", badge: "Worker" },
      { id: "isAvailable", label: "Availability", badge: "Worker" },
      { id: "street", label: "Street", badge: "Worker" },
      { id: "city", label: "Suburb", badge: "Worker" },
      { id: "postalCode", label: "Postal Code", badge: "Worker" },
      { id: "state", label: "State", badge: "Worker" },
      { id: "country", label: "Country", badge: "Worker" },
      { id: "dob", label: "DOB", badge: "Worker" },
      { id: "phoneNumber", label: "Phone Number", badge: "Worker" },
      { id: "fullAddress", label: "Full Address", badge: "Worker" },
      { id: "nextOfKinName", label: "Next-of-Kin", badge: "Worker" },
      { id: "usiNumber", label: "USI Number", badge: "Worker" },
    ],
  },
  {
    category: "Experience",
    fields: [
      { id: "employer", label: "Employer", badge: "Job History" },
      { id: "projectName", label: "Project Name",badge: "Job History"},
      { id: "experienceJobTitle", label: "Job Title", badge: "Job History" },
      { id: "experienceIndustry", label: "Industry", badge: "Job History" },
      { id: "experienceDiscipline", label: "Discipline", badge: "Job History" },
      { id: "inductions", label: "Inductions", badge: "Job History" },
      { id: "skills", label: "Skills", badge: "Job History" },
      { id: "uploadResume", label: "CV Uploaded"},
      { id: "profileSummaryDescription", label: "Profile Summary", badge: "Job History" },
      { id: "experienceStartDate", label: "Start Date", badge: "Job History" },
      { id: "experienceEndDate", label: "End Date", badge: "Job History" },
      { id: "refereeName", label: "Referee", badge: "Job History" },
      { id: "introVideo", label: "Intro Video Uploaded", badge: "Job History" },
    ],
  },
  {
    category: "Qualifications & ID Documents",
    fields: [
      
    
      // { id: "licenceType", label: "Licence Type", badge: "Qualification" },
    

      { id: "uploadQualification", label: "Qualification"},
      { id: "soa", label: "Qualification SOA"},
      { id: "voc", label: "Qualification VOC", },
   
    
      { id: "driversLicenseClass", label: "Driver Licence"},
    
      
   
      
      { id: "passportExpiryDate", label: "Passport"},
    
    
      { id: "photoAgeExpiryDate", label: "Photo Age" },
     
    ],
  },
  {
    category: "Working rights",
    fields: [
      { id: "citizenship", label: "Citizenship", badge: "Worker" },
    
      { id: "visaUpload", label: "Visa"},
      { id: "policeClearanceUploaded", label: "Police Clearance" },
  
    ],
  },
  {
    category: "Other",
    fields: [
     
      { id: "lslState", label: "LSL" , badge: "Worker"},
      { id: "travelPreferredAirline", label: "Preferred Airline & FFN"},
      // { id: "travelFrequentFlyerNumber", label: "Frequent Flyer No.", badge: "Candidate" },
     
      { id: "ppeBootsSize", label: "PPE", badge: "Worker" },
      { id: "medicalAssessments", label: "Medical" },
  
      // { id: "superannuationFundName", label: "Fund Name", badge: "Superannuation" },
      // { id: "superannuationFundUsiAbn", label: "Fund USI/ABN", badge: "Superannuation" },
      // { id: "superannuationMemberNumber", label: "Member Number", badge: "Superannuation" },
    ],
  },
  {
    category: "Advert information",
    fields: [
      { id: "campaignName", label: "Campaign / Project Name",},
      { id: "advertId", label: "Advert Name / Job Title",},
      { id: "projectCode", label: "Advert Project Code",},
      { id: "campaignIndustry", label: "Advert Industry",},
      { id: "campaignSuburb", label: "Advert Suburb",},
      { id: "campaignState", label: "Advert State",},
      { id: "campaignPostalCode", label: "Advert Postal Code",},
      { id: "campaignUsers", label: "Advert Users",},
      { id: "salary", label: "Advert Rate/Salary",},
      { id: "roster", label: "Advert Roster",},
      { id: "hours", label: "Advert Weekly Hours",},
      { id: "jobDuration", label: "Advert Job Duration",},
      { id: "employmentType", label: "Advert Employment Type",},
      { id: "advertDiscipline", label: "Advert Discipline", },
      { id: "targetHeadcount", label: "Advert Target Headcount",},
      { id: "campaignTargetHeadcount", label: "Campaign Target Headcount",},
      { id: "startDate", label: "Advert Start Date",},
      { id: "advertEndDate", label: "Advert End Date",},
      { id: "jobDescription", label: "Advert Description",},
    ],
  },
  {
    category: "Compliance & Status",
    fields: [
      // { id: "hardRequirements", label: "Hard Requirements", badge: "Compliance" },
      // { id: "softRequirements", label: "Soft Requirements", badge: "Compliance" },
      { id: "hardComplianceStatus", label: "Hard Tracker Status", badge: "Advert" },
      { id: "softComplianceStatus", label: "Soft Tracker Status", badge: "Advert" },
      { id: "notes", label: "Candidate Notes", badge: "Advert" },
    ],
  },
  {
    category: "Approval & Status",
    fields: [
      { id: "invited", label: "Invited", badge: "Status" },
      { id: "applied", label: "Applied", badge: "Status" },
      { id: "shortlistsOffered", label: "Shortlists Offered", badge: "Status" },
      { id: "hardReview", label: "Hard Review", badge: "Status" },
      { id: "roleOffered", label: "Role Offered", badge: "Status" },
      { id: "roleAccepted", label: "Role Accepted", badge: "Status" },
    
    ],
  },
  {
    category: "User Actions",
    fields: [
      { id: "isApproved", label: "Accept or Reject ", badge: "Actions" },
      { id: "auditTrails", label: "Audit Trails"},
      // { id: "isApprovedByUser", label: "Action by user", badge: "Advert Status" },
    ],
  },
  {
    category: "Account User List",
    fields: [
      { id: "userName", label: "User Account Name" },
      { id: "userType", label: "User Account Permission",},
      { id: "userStatus", label: "User Account Status",},
    ],
  },
  // {
  //   category: "Mobilisation Management",
  //   fields: [
  //     // { id: "gates", label: "Gates", },
  //   ],
  // },
].map((group) => ({
  ...group,
  fields: [...group.fields]
    .map((field) => ({ ...field, label: formatReportFieldLabel(field) }))
    .sort((a, b) => compareAlphaLabels(a.label, b.label)),
}));


const COMPLIANCE_STATUS_OPTIONS = [
  { value: "Fully meets", label: "Fully meets" },
  { value: "Partially meets", label: "Partially meets" },
  { value: "Doesn't meet", label: "Doesn't meet" },
];

const CANDIDATE_STATUS_OPTIONS = [
  { value: "invited", label: "Invited" },
  { value: "applied", label: "Applied" },
  { value: "shortlistsOffered", label: "Shortlists Offered" },
  { value: "hardReview", label: "Hard Review" },
  { value: "roleOffered", label: "Role Offered" },
  { value: "roleAccepted", label: "Role Accepted" },
];

const CANDIDATE_STATUS_FILTER_KEY = "candidate_status";

const CANDIDATE_STATUS_PAYLOAD_KEYS = CANDIDATE_STATUS_OPTIONS.map((option) => option.value);

const COMPLIANCE_STATUS_FIELDS = ["hardComplianceStatus", "softComplianceStatus"];

const normalizePreviewFieldKey = (fieldId) =>
  String(fieldId || "")
    .toLowerCase()
    .replace(/[^a-z]/g, "");

const isAcceptRejectField = (fieldId) => {
  const key = normalizePreviewFieldKey(fieldId);
  return key === "isapproved" || key.includes("acceptorreject");
};

const getAcceptRejectActionClass = (row, fieldId) => {
  if (!isAcceptRejectField(fieldId)) return "";
  const raw = row?.action ?? row?.isApproved ?? row?.Action ?? "";
  const status = String(raw).trim().toLowerCase();
  if (status === "accepted" || status === "accept") return "action-accepted";
  if (status === "rejected" || status === "reject") return "action-rejected";
  return "";
};

const MULTI_VALUE_FIELDS = [
  "qualificationType",
  "skills",
  "inductions",
  "licenceType",
  "visaType",
  "medicalAssessments",
  "driversLicenseClass",
  "driversLicenseConditions",
  "campaignUsers",
  "soa",
  "voc",
  "qualificationMemberId",
  "qualificationIssueDate",
  "qualificationExpiryDate",
  "qualificationVerificationStatus",
  "vocType",
];

const getTrafficLightStatus = (value) => {
  if (value === true) return "yes";
  if (value === false) return "no";
  const status = String(value ?? "").trim().toLowerCase();
  if (status === "yes" || status === "true") return "yes";
  if (status === "no" || status === "false") return "no";
  if (status === "warning") return "warning";
  return null;
};

const renderYesNoTrafficLight = (value) => {
  const status = getTrafficLightStatus(value);
  if (status === "yes") {
    return (
      <Tooltip title="Yes">
        <span className="traffic-light">
          <img src={SuccessIcon} alt="Yes" className="traffic-light-icon" />
        </span>
      </Tooltip>
    );
  }
  if (status === "warning") {
    return (
      <Tooltip title="Warning">
        <span className="traffic-light">
          <img src={WarningIcon} alt="Warning" className="traffic-light-icon" />
        </span>
      </Tooltip>
    );
  }
  if (status === "no") {
    return (
      <Tooltip title="No">
        <span className="traffic-light">
          <img src={StopIcon} alt="No" className="traffic-light-icon" />
        </span>
      </Tooltip>
    );
  }
  return null;
};

const getCellListItems = (fieldId, value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) => (item && typeof item === "object" ? item.name ?? item.label : item))
      .filter((item) => item !== null && item !== undefined && String(item).trim() !== "")
      .map((item) => String(item).trim());
  }

  if (!MULTI_VALUE_FIELDS.includes(fieldId) || typeof value !== "string") return [];

  return value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

const renderBulletList = (items) => (
  <ul className="cell-bullet-list">
    {items.map((item, index) => (
      <li key={`${item}-${index}`}>{item}</li>
    ))}
  </ul>
);

const CITIZENSHIP_OPTIONS = [
  { value: "Australian", label: "Australian" },
  { value: "Non-Australian", label: "Non-Australian" },
];

const YES_NO_OPTIONS = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const USER_TYPE_OPTIONS = [
  { value: "Admin", label: "Admin" },
  { value: "Standard", label: "Standard" },
  { value: "Associate", label: "Associate" },
];

const USER_STATUS_OPTIONS = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

const AUDIT_TRAIL_STATUS_OPTIONS = [
  { value: "invited", label: "Invited" },
  { value: "applied", label: "Applied" },
  { value: "shortlists offered", label: "Shortlists Offered" },
  { value: "hard review", label: "Hard Review" },
  { value: "role offered", label: "Role Offered" },
  { value: "role accepted", label: "Role Accepted" },
  { value: "released", label: "Released" },
];

/** Map legacy camelCase audit-trail values to the API's space-separated form. */
const AUDIT_TRAIL_STATUS_VALUE_MAP = {
  shortlistsoffered: "shortlists offered",
  hardreview: "hard review",
  roleoffered: "role offered",
  roleaccepted: "role accepted",
};

const normalizeAuditTrailStatusValue = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  const mapped = AUDIT_TRAIL_STATUS_VALUE_MAP[trimmed.toLowerCase().replace(/\s+/g, "")];
  return mapped || trimmed.toLowerCase();
};

const BASE_FILTER_KEY_OPTIONS = [
  { value: "advert_discipline", label: "Advert Discipline", valueType: "dropdown", apiType: "DISCIPLINE" },
  { value: "advert_end_date", label: "Advert End Date", valueType: "date" },
  { value: "advert_name", label: "Advert Name / Job Title", valueType: "dropdown", apiType: "ADVERT" },
  { value: "advert_job_title", label: "Job Title (Job History)", valueType: "dropdown", apiType: "JOBTITLE" },
  { value: "advert_start_date", label: "Advert Start Date", valueType: "date" },
  { value: "targetHeadcount", label: "Advert Target Headcount", valueType: "dropdown", apiType: "ADVERT_TARGET_HEADCOUNT" },
  { value: "auditTrailStatus", label: "Audit Trail Status", valueType: "dropdown", staticOptions: AUDIT_TRAIL_STATUS_OPTIONS },
  { value: "auditTrailUser", label: "Audit Trail User", valueType: "dropdown", apiType: "USER" },
  { value: "availability", label: "Notice Period (Worker)", valueType: "dropdown", apiType: "AVAILABILITY" },
  { value: "isAvailable", label: "Availability (Worker)", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "campaign_industry", label: "Advert Industry", valueType: "dropdown", apiType: "INDUSTRY" },
  { value: "campaign_name", label: "Campaign / Project Name", valueType: "dropdown", apiType: "CAMPAIGN" },
  { value: "campaign_postal_code", label: "Advert  Postal Code", valueType: "text" },
  { value: "campaign_state", label: "Advert State", valueType: "dropdown", apiType: "LOCATION" },
  { value: "campaign_suburb", label: "Advert Suburb", valueType: "dropdown", apiType: "LOCATION" },
  { value: "candidate_name", label: "Full Name (Worker)", valueType: "text" },
  { value: "citizenship", label: "Citizenship (Worker)", valueType: "dropdown", staticOptions: CITIZENSHIP_OPTIONS },
  { value: "city_suburb", label: "Suburb (Worker)", valueType: "dropdown", apiType: "LOCATION_CITY" },
  { value: "country", label: "Country (Worker)", valueType: "dropdown", apiType: "LOCATION_COUNTRY" },
  { value: "discipline", label: "Discipline (Worker)", valueType: "dropdown", apiType: "DISCIPLINE" },
  { value: "discipline_auto", label: "Discipline (Job History)", valueType: "dropdown", apiType: "DISCIPLINE" },
  { value: "drivers_class", label: "Driver Licence Class", valueType: "dropdown", apiType: "LICENCE_CLASS" },
  { value: "drivers_conditions", label: "Driver Licence Conditions", valueType: "dropdown", apiType: "LICENCE_CONDITION" },
  { value: "drivers_expiry_date", label: "Driver Licence Expiry", valueType: "date" },
  { value: "drivers_license_number", label: "Driver Licence Number", valueType: "text" },
  { value: "drivers_state", label: "Driver Licence State", valueType: "dropdown", apiType: "STATE" },
  { value: "uploadDrivingLicence", label: "Driver Licence Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "email", label: "Email (Worker)", valueType: "text" },
  { value: "employer", label: "Employer (Job History)", valueType: "text" },
  { value: "employment_type", label: "Advert Employment Type", valueType: "dropdown", apiType: "EMPLOYMENT_TYPE" },
  { value: "ethnicity", label: "Ethnicity (Worker)", valueType: "dropdown", apiType: "ETHNICITY" },
  { value: "first_name", label: "First Name (Worker)", valueType: "text" },
  { value: "gender", label: "Gender (Worker)", valueType: "dropdown", apiType: "GENDER" },
  { value: "hard_compliance_status", label: "Hard Tracker Status (Advert)", valueType: "dropdown", staticOptions: COMPLIANCE_STATUS_OPTIONS },
  { value: "hours", label: "Advert Weekly Hours", valueType: "text" },
  { value: "job_duration", label: "Advert Job Duration", valueType: "dropdown", apiType: "JOB_DURATION" },
  { value: "inductions", label: "Inductions (Job History)", valueType: "dropdown", apiType: "INDUCTION" },
  { value: "industry", label: "Industry (Job History)", valueType: "dropdown", apiType: "INDUSTRY" },
  { value: "last_name", label: "Last Name (Worker)", valueType: "text" },
  { value: "licence_type_class", label: "Qualification Classification", valueType: "dropdown", apiType: "LICENCETYPE" },
  { value: "lslMemberNumber", label: "LSL Member Number", valueType: "text" },
  { value: "lsl_state", label: "LSL State", valueType: "dropdown", apiType: "LOCATION_STATE" },
  { value: "medical_assessment", label: "Medical Name", valueType: "dropdown", apiType: "MEDICAL_ASSESSMENT" },
  { value: "medicalIssueDate", label: "Medical Issued", valueType: "date" },
  { value: "medicalUpload", label: "Medical Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "nextOfKinName", label: "NOK Name (Worker)", valueType: "text" },
  { value: "nextOfKinContact", label: "NOK Contact Details (Worker)", valueType: "text" },
  { value: "nextOfKinRelation", label: "NOK Relationship (Worker)", valueType: "dropdown", apiType: "RELATION" },
  { value: "passport_nationality", label: "Passport Nationality", valueType: "text" },
  { value: "passportNumber", label: "Passport Number", valueType: "text" },
  { value: "passportExpiryDate", label: "Passport Expiry", valueType: "date" },
  { value: "uploadPassport", label: "Passport Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "photo_age_state", label: "Photo Age State", valueType: "dropdown", apiType: "LOCATION_STATE" },
  { value: "photoAgeIdNumber", label: "Photo Age ID Number", valueType: "text" },
  { value: "photoAgeExpiryDate", label: "Photo Age Expiry", valueType: "date" },
  { value: "photoAgeUploaded", label: "Photo Age Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "policeClearanceUploaded", label: "Police Clearance Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "policeClearanceCertifyingAuthority", label: "Police Clearance Certifier", valueType: "dropdown", apiType: "CERTIFYING_AUTHORITY" },
  { value: "policeClearanceIssueDate", label: "Police Clearance Issued", valueType: "date" },
  { value: "postal_code", label: "Postal Code (Worker)", valueType: "dropdown", apiType: "LOCATION_POSTAL_CODE" },
  { value: "ppeShirtSize", label: "PPE Shirt Size", valueType: "dropdown", apiType: "SHIRT" },
  { value: "ppePantsSize", label: "PPE Pants Size", valueType: "dropdown", apiType: "PANTS" },
  { value: "ppeBootsSize", label: "PPE Boots Size", valueType: "dropdown", apiType: "BOOTS" },
  { value: "project_code", label: "Advert Project Code", valueType: "dropdown", apiType: "PROJECT_CODE" },
  { value: "project_name", label: "Project Name(Job History)", valueType: "text" },
  
  { value: "qualification", label: "Qualification Name", valueType: "dropdown", apiType: "QUALIFICATION" },
  { value: "qualification_state", label: "Qualification State", valueType: "dropdown", apiType: "QUALIFICATION_STATE" },
  { value: "qualificationMemberId", label: "Qualification Member No.", valueType: "text" },
  { value: "qualificationIssueDate", label: "Qualification Issued", valueType: "date" },
  { value: "qualificationExpiryDate", label: "Qualification Expiry", valueType: "date" },
  // { value: "qualificationVerificationStatus", label: "Verification Status (Qualification)", valueType: "text" },
  { value: "uploadQualification", label: "Qualification Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "soa", label: "Qualification SOA", valueType: "dropdown", apiType: "QUALIFICATION" },
  { value: "voc", label: "VOC Issued", valueType: "text" },
  { value: "vocUploaded", label: "VOC Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS},
  { value: "vocType", label: "VOC Type", valueType: "dropdown", apiType: "VOC" },
  { value: "uploadResume", label: "CV Uploaded ", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "refereeName", label: "Referee Name (Job History)", valueType: "text" },
  { value: "refereePosition", label: "Referee Role (Job History)", valueType: "text" },
  { value: "refereeContact", label: "Referee Details (Job History)", valueType: "text" },
  { value: "roster", label: "Advert Roster", valueType: "dropdown", apiType: "ROSTER" },
  { value: "salary_rate", label: "Advert Rate/Salary", valueType: "dropdown", apiType: "SALARY_RATE" },
  { value: "skills", label: "Skills (Job History)", valueType: "dropdown", apiType: "SKILL" },
  { value: "soft_compliance_status", label: "Soft Tracker Status (Advert)", valueType: "dropdown", staticOptions: COMPLIANCE_STATUS_OPTIONS },
  { value: "state", label: "State (Worker)", valueType: "dropdown", apiType: "LOCATION_STATE" },
  { value: "candidate_status", label: "Status", valueType: "dropdown", staticOptions: CANDIDATE_STATUS_OPTIONS },
  { value: "street", label: "Street (Worker)", valueType: "dropdown", apiType: "LOCATION_STREET" },
  { value: "campaignTargetHeadcount", label: "Campaign Target Headcount", valueType: "text" },
  { value: "users", label: "Advert Users", valueType: "dropdown", apiType: "USER" },
  { value: "userName", label: "User Account Name", valueType: "dropdown", apiType: "USER" },
  { value: "userStatus", label: "User Account Status", valueType: "dropdown", staticOptions: USER_STATUS_OPTIONS },
  { value: "userType", label: "User Account Permission", valueType: "dropdown", staticOptions: USER_TYPE_OPTIONS },
  { value: "visa_type_number", label: "Visa Name", valueType: "dropdown", apiType: "VISA" },
  { value: "visaGrantNumber", label: "Visa Grant Number", valueType: "text" },
  { value: "visaIssueDate", label: "Visa Issued ", valueType: "date" },
  { value: "visaExpiryDate", label: "Visa Expiry Date", valueType: "date" },
  { value: "visaUpload", label: "Visa Uploaded", valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
  { value: "introVideo", label: "Intro Video Uploaded (Job History)",  valueType: "dropdown", staticOptions: YES_NO_OPTIONS },
].map((item) => ({ ...item, label: formatLabelSpacing(item.label) }));

const OPERATOR_OPTIONS = [
  { value: "containsAll", label: "Contains All" },
  { value: "contains", label: "Contains Any" },
  { value: "notContains", label: "Not Contain" },
];

const BOOLEAN_OPTION_VALUES = new Set(["yes", "no", "true", "false"]);

const isBooleanDropdownFilter = (keyConfig) => {
  if (!keyConfig || keyConfig.valueType !== "dropdown") return false;
  if (keyConfig.staticOptions === YES_NO_OPTIONS) return true;
  const options = keyConfig.staticOptions || keyConfig.options || [];
  if (options.length === 0 || options.length > 2) return false;
  return options.every((option) =>
    BOOLEAN_OPTION_VALUES.has(String(option?.value ?? "").trim().toLowerCase())
  );
};

const BOOLEAN_OPERATOR_OPTIONS = [
  { value: "contains", label: "Contains" },
  { value: "notContains", label: "Not Contains" },
];

const getOperatorOptions = (keyConfig) =>
  isBooleanDropdownFilter(keyConfig)
    ? BOOLEAN_OPERATOR_OPTIONS
    : OPERATOR_OPTIONS;

const MULTI_SELECT_FILTER_KEYS = [
  "gender",
  "ethnicity",
  "discipline",
  "discipline_auto",
  "start_notice_period",
  "city_suburb",
  "state",
  "state_country",
  "country",
  "suburb",
  "street",
  "postal_code",
  "project_name",
  "project_code",
  "advert_name",
  "advert_job_title",
  "industry",
  "campaign_industry",
  "campaign_name",
  "campaign_state",
  "inductions",
  "skills",
  "qualification",
  "soa",
  "qualification_state",
  "licence_type_class",
  "visa_type_number",
  "medical_assessment",
  "policeClearanceCertifyingAuthority",
  "drivers_state",
  "lsl_state",
  "drivers_class",
  "drivers_conditions",
  "photo_age_state",
  "users",
  "salary_rate",
  "roster",
  "job_duration",
  "employment_type",
  "advert_discipline",
  "hard_compliance_requirements",
  "soft_compliance_requirements",
  "hard_compliance_status",
  "soft_compliance_status",
  "candidate_status",
  "userName",
  "userStatus",
  "userType",
  "nextOfKinRelation",
  "availability",
  "vocType",
  "ppeBootsSize",
  "ppePantsSize",
  "ppeShirtSize",
  "targetHeadcount",
  "auditTrailStatus",
  "auditTrailUser",
];

const toArrayValue = (value) => {
  if (Array.isArray(value)) return value;
  if (value === undefined || value === null || value === "") return [];
  return [value];
};

const splitCommaSeparatedValues = (value) =>
  toArrayValue(value).flatMap((item) => {
    if (item === undefined || item === null || item === "") return [];
    return String(item)
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);
  });

const expandSalaryFilterValues = (values) => {
  const seen = new Set();
  return toArrayValue(values)
    .flatMap((item) =>
      String(item ?? "")
        .replace(/\$/g, "")
        .split("-")
        .map((part) => part.trim())
        .filter(Boolean)
    )
    .filter((part) => {
      if (seen.has(part)) return false;
      seen.add(part);
      return true;
    })
    .sort((a, b) => {
      const aNum = Number(a);
      const bNum = Number(b);
      if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) return aNum - bNum;
      return a.localeCompare(b, undefined, { numeric: true });
    });
};

const isTextFilterValue = (keyConfig) =>
  keyConfig?.valueType === "text" || !keyConfig?.valueType;

const FILTER_KEY_OVERRIDES = {
  advert_end_date: "advertEndDate",
  advert_name: "advertId",
  advert_job_title: "experienceJobTitle",
  advert_start_date: "startDate",
  availability: "availabilityDetails",
  industry: "experienceIndustry",
  discipline_auto: "experienceDiscipline",
  city_suburb: "city",
  zip_postal_code: "postalCode",
  drivers_class: "driversLicenseClass",
  drivers_conditions: "driversLicenseConditions",
  drivers_expiry_date: "driversLicenseExpiry",
  drivers_license_number: "driversLicenseNumber",
  drivers_state: "driversLicenseState",
  licence_type_class: "licenceType",
  qualification: "qualificationType",
  medical_assessment: "medicalAssessments",
  salary_rate: "salary",
  users: "campaignUsers",
  visa_type_number: "visaType",
  job_duration: "jobDuration",
  auditTrailStatus: "auditTrails",
};

const convertKeyToCamelCase = (key) => {
  if (FILTER_KEY_OVERRIDES[key]) {
    return FILTER_KEY_OVERRIDES[key];
  }
  return key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

const NAME_VALUED_TAG_TYPES = ["GENDER", "STATE", "LICENCE_CLASS", "LICENCE_CONDITION", "EMPLOYMENT_TYPE", "VISA", "BOOTS", "PANTS", "SHIRT", "CERTIFYING_AUTHORITY"];

const resolveValueNames = (keyConfig, values) => {
  const options = keyConfig?.options || [];
  if (!options.length) return values;

  return values.map((value) => {
    const match = options.find(
      (option) => String(option.value).toLowerCase() === String(value).toLowerCase()
    );
    // Prefer the dropdown display label (e.g. "Advert Name - Campaign Name")
    return match?.label ?? match?.name ?? value;
  });
};

const STATE_FILTER_KEYS = [
  "state",
  "state_country",
  "campaign_state",
  "lsl_state",
  "photo_age_state",
];

const splitLocation = (value) =>
  String(value).split(",").map((part) => part.trim()).filter(Boolean);

const extractStateFromLocation = (value) => {
  if (typeof value !== "string") return value;

  const parts = splitLocation(value);
  if (parts.length >= 3) return parts[1];
  if (parts.length === 2) return /^\d+$/.test(parts[1]) ? parts[0] : parts[1];
  return value;
};

const LOCATION_COLLECTION_KEYS = {
  city: ["city", "cities"],
  state: ["state", "states"],
  country: ["country", "countries"],
  postalCode: ["postalCode", "postalCodes", "postal_code", "postal_codes"],
  street: ["street", "streets"],
};

const extractLocationList = (response, type) => {
  const payload = response?.data?.data ?? response?.data ?? response;
  if (Array.isArray(payload)) return payload;

  const keys = [
    "result",
    "list",
    "items",
    "data",
    type,
    `${type}s`,
    ...(LOCATION_COLLECTION_KEYS[type] || []),
  ];

  if (payload && typeof payload === "object") {
    for (const key of keys) {
      if (Array.isArray(payload[key])) return payload[key];
    }
  }

  return [];
};

const isMongoObjectId = (value) => /^[a-f0-9]{24}$/i.test(String(value || "").trim());

const extractLocationName = (item, type) => {
  if (typeof item === "string") {
    const name = item.trim();
    return isMongoObjectId(name) ? "" : name;
  }
  if (!item || typeof item !== "object") return "";

  const name =
    item[type] ??
    (type === "postalCode" ? item.postal_code : undefined) ??
    item.name ??
    item.label ??
    item.value ??
    "";
  const normalized = typeof name === "string" ? name.trim() : String(name || "").trim();
  return isMongoObjectId(normalized) ? "" : normalized;
};

const buildLocationListOptions = (locations, type) => {
  const seen = new Set();

  return locations.reduce((acc, item) => {
    const name = extractLocationName(item, type);
    if (!name) return acc;

    const key = name.toLowerCase();
    if (seen.has(key)) return acc;

    seen.add(key);
    acc.push({ label: name, value: name });
    return acc;
  }, []).sort((a, b) => a.label.localeCompare(b.label));
};

const readCampaignName = (value) => {
  if (!value) return "";
  if (Array.isArray(value)) return readCampaignName(value[0]);
  if (typeof value === "object") {
    return String(value.campaignName || value.name || "").trim();
  }
  return "";
};

const extractCampaignName = (advert) => {
  const plainName = [advert?.campaign, advert?.campaignName].find(
    (value) => typeof value === "string" && value.trim()
  );

  return (
    plainName?.trim() ||
    readCampaignName(advert?.campaign) ||
    readCampaignName(advert?.campaignId)
  );
};

const ALL_FIELDS = FIELD_GROUPS.flatMap((group) => group.fields);

const getFieldLabel = (fieldId) => {
  const key = getColumnKey(fieldId);
  return ALL_FIELDS.find((field) => field.id === key)?.label || getResponseColumnLabel(fieldId);
};

// Filter-only parent so criteria grouping matches Available Fields without changing export columns.
const FILTER_PARENT_FIELD_MAP = {
  vocUploaded: "voc",
  qualification: "uploadQualification",
  licence_type_class: "uploadQualification",
  auditTrailStatus: "auditTrails",
  auditTrailUser: "auditTrails",
};

const getFilterCategory = (filterValue) => {
  if (filterValue === CANDIDATE_STATUS_FILTER_KEY) return "Approval & Status";
  const fieldId =
    FILTER_PARENT_FIELD_MAP[filterValue] || convertKeyToCamelCase(filterValue);
  const direct = FIELD_GROUPS.find((group) =>
    group.fields.some((field) => field.id === fieldId)
  );
  if (direct) return direct.category;

  const parentId = Object.keys(FIELD_EXPORT_COLUMN_MAP).find((parent) =>
    FIELD_EXPORT_COLUMN_MAP[parent].includes(fieldId)
  );
  if (parentId) {
    return (
      FIELD_GROUPS.find((group) =>
        group.fields.some((field) => field.id === parentId)
      )?.category || ""
    );
  }
  return "";
};

const getFilterSortLabel = (filterValue, fallbackLabel = "") =>
  BASE_FILTER_KEY_OPTIONS.find((item) => item.value === filterValue)?.label ||
  fallbackLabel;

const FILTERS_WITHOUT_FIELD_BADGE = new Set(["soa", "voc", "vocType"]);

const getFilterSearchMeta = (filterValue) => {
  if (!filterValue) {
    return { label: "", badge: "", category: "", fieldId: "" };
  }

  const fieldId = convertKeyToCamelCase(filterValue);
  const field = ALL_FIELDS.find((entry) => entry.id === fieldId);
  const parentId = Object.keys(FIELD_EXPORT_COLUMN_MAP).find((parent) =>
    FIELD_EXPORT_COLUMN_MAP[parent].includes(fieldId)
  );
  const parentField = parentId
    ? ALL_FIELDS.find((entry) => entry.id === parentId)
    : null;
  const baseLabel =
    BASE_FILTER_KEY_OPTIONS.find((item) => item.value === filterValue)?.label ||
    field?.label ||
    "";
  const badgeFromLabel = ((baseLabel.match(/\(([^)]+)\)\s*$/) || [])[1] || "").trim();
  const advertPrefix = /^Advert\b/i.test(baseLabel) ? "Advert" : "";
  const hideFieldBadge = FILTERS_WITHOUT_FIELD_BADGE.has(filterValue);

  return {
    label: baseLabel,
    badge: hideFieldBadge
      ? ""
      : field?.badge ||
        parentField?.badge ||
        badgeFromLabel ||
        advertPrefix ||
        "",
    category: getFilterCategory(filterValue),
    fieldId,
  };
};

const SAVED_KEY_TO_FILTER_KEY = BASE_FILTER_KEY_OPTIONS.reduce((acc, option) => {
  acc[convertKeyToCamelCase(option.value)] = option.value;
  return acc;
}, {});

export const mapSavedReportToConfig = (report) => {
  const savedFilters = Array.isArray(report?.filters) ? report.filters : [];
  const selectedStatuses = [];

  const mappedFilters = savedFilters.reduce((acc, filter) => {
    if (CANDIDATE_STATUS_PAYLOAD_KEYS.includes(filter?.key)) {
      selectedStatuses.push(filter.key);
      return acc;
    }

    const key = SAVED_KEY_TO_FILTER_KEY[filter?.key] || filter?.key || "";
    const keyConfig = BASE_FILTER_KEY_OPTIONS.find((option) => option.value === key);
    const values = (Array.isArray(filter?.value) ? filter.value : [filter?.value]).map(
      (item) =>
        key === "auditTrailStatus" ? normalizeAuditTrailStatusValue(item) : item
    );

    let value = "";
    if (keyConfig?.valueType === "date" && values.length > 1) {
      value = JSON.stringify({ startDate: values[0], endDate: values[1] });
    } else if (MULTI_SELECT_FILTER_KEYS.includes(key)) {
      value = values.filter((item) => item !== undefined && item !== null);
    } else if (isTextFilterValue(keyConfig)) {
      value = splitCommaSeparatedValues(values).join(", ");
    } else if (values[0] !== undefined && values[0] !== null) {
      value = values[0];
    }

    acc.push({
      key,
      operator: isBooleanDropdownFilter(keyConfig)
        ? filter?.operator === "notContains"
          ? "notContains"
          : "contains"
        : filter?.operator || "contains",
      value,
    });
    return acc;
  }, []);

  if (selectedStatuses.length) {
    mappedFilters.push({
      key: CANDIDATE_STATUS_FILTER_KEY,
      operator: "contains",
      value: selectedStatuses,
    });
  }

  return {
    reportId: report?._id || report?.id || null,
    reportTitle: report?.name || "Untitled report",
    selectedFields: normalizeReportColumnIds(
      report?.cols || report?.columns || [],
      ALL_FIELDS
    ),
    filters: mappedFilters,
  };
};

const renderOmittedTags = (omittedValues) => {
  const labels = omittedValues
    .map(({ label, value }) => label ?? value)
    .filter(Boolean);

  return (
    <Tooltip
      overlayClassName="omitted-tags-tooltip"
      title={
        <ul>
          {labels.map((item, index) => (
            <li key={`${item}-${index}`}>{item}</li>
          ))}
        </ul>
      }
      placement="top"
    >
      <span>+ {omittedValues.length} ...</span>
    </Tooltip>
  );
};

const FilterRow = ({
  filter,
  index,
  onUpdate,
  onRemove,
  filterKeyOptions,
  usedKeys = [],
  optionsLoading = false,
  optionsFailed = false,
  onLoadValueOptions,
}) => {
  const selectedKeyConfig = filterKeyOptions.find((k) => k.value === filter.key);
  const isDropdownValue = selectedKeyConfig?.valueType === "dropdown";
  const isDateValue = selectedKeyConfig?.valueType === "date";
  const isTextValue = selectedKeyConfig?.valueType === "text" || !selectedKeyConfig?.valueType;
  const isBooleanValue = isBooleanDropdownFilter(selectedKeyConfig);
  const isMultiSelect = Boolean(selectedKeyConfig?.multiSelect) && !isTextValue;
  const operatorOptions = getOperatorOptions(selectedKeyConfig);
  const valueOptions = selectedKeyConfig?.options || [];
  const isValueOptionsLoading = Boolean(selectedKeyConfig?.apiType) && optionsLoading;


  const filterOption = (input, option) =>
    String(option?.label ?? "")
      .toLowerCase()
      .includes(String(input).toLowerCase());

  const matchesCriteriaOption = (input, option) => {
    if (!option) return false;
    const value = option.value ?? option.data?.value;
    const optionLabel = [option.label, option.data?.label].find(
      (label) => typeof label === "string"
    );
    const meta = getFilterSearchMeta(value);
    // the group name is deliberately left out, otherwise every option in a
    // category matches as soon as the category name does
    return matchesReportSearch(input, optionLabel, meta.label, meta.badge);
  };

  const filterCriteriaOption = (input, option) => {
    // a matching group keeps all of its children, so only leaves may match
    if (option?.options) return false;
    return matchesCriteriaOption(input, option);
  };

  const keyOptions = useMemo(() => {
    const takenKeys = new Set(usedKeys.filter((key) => key && key !== filter.key));
    const options = filterKeyOptions.map((option) => {
      const meta = getFilterSearchMeta(option.value);
      return {
        value: option.value,
        label: option.label,
        badge: meta.badge,
        disabled: takenKeys.has(option.value),
      };
    });
    if (filter.key && !options.some((option) => option.value === filter.key)) {
      options.push({
        value: filter.key,
        label: getFilterSortLabel(filter.key, getFieldLabel(filter.key)),
      });
    }

    const sortFilterOptions = (list) =>
      [...list].sort((a, b) =>
        compareAlphaLabels(
          getFilterSortLabel(a.value, a.label),
          getFilterSortLabel(b.value, b.label)
        )
      );

    const grouped = FIELD_GROUPS.map((group) => ({
      label: group.category,
      options: sortFilterOptions(
        options.filter((option) => getFilterCategory(option.value) === group.category)
      ),
    })).filter((group) => group.options.length > 0);

    const groupedValues = new Set(grouped.flatMap((group) => group.options.map((option) => option.value)));
    const ungrouped = sortFilterOptions(
      options.filter((option) => !groupedValues.has(option.value))
    );

    if (ungrouped.length) {
      const existingOther = grouped.find(
        (group) => String(group.label).toLowerCase() === "other"
      );
      if (existingOther) {
        existingOther.options = sortFilterOptions([
          ...existingOther.options,
          ...ungrouped,
        ]);
      } else {
        grouped.push({ label: "Other", options: ungrouped });
      }
    }

    return grouped;
  }, [filterKeyOptions, filter.key, usedKeys]);

  const resolveOptionValue = (value) => {
    if (!value) return undefined;
    const match = valueOptions.find(
      (option) => String(option.value).toLowerCase() === String(value).toLowerCase()
    );
    return match ? match.value : value;
  };

  const handleDateRangeChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      const dateRange = {
        startDate: dates[0].format("YYYY-MM-DD"),
        endDate: dates[1].format("YYYY-MM-DD"),
      };
      onUpdate(index, "value", JSON.stringify(dateRange));
    } else {
      onUpdate(index, "value", "");
    }
  };

  const parseDateValue = () => {
    if (!filter.value) return null;
    try {
      const parsed = JSON.parse(filter.value);
      if (parsed.startDate && parsed.endDate) {
        return [dayjs(parsed.startDate), dayjs(parsed.endDate)];
      }
    } catch (e) {
      return null;
    }
    return null;
  };

  return (
    <div className="filter-row">
      <div className="filter-field">
        <label className="filter-label">Criteria</label>
        <Select
          className="filter-select"
          placeholder="Select criteria"
          value={filter.key || undefined}
          onChange={(value) => onUpdate(index, "key", value)}
          showSearch
          optionFilterProp="label"
          filterOption={filterCriteriaOption}
          options={keyOptions}
          popupClassName="filter-criteria-dropdown"
          getPopupContainer={(trigger) => trigger.parentNode}
        />
      </div>
      {!isDateValue && (
        <div className="filter-field filter-field-rule">
          <label className="filter-label">Rule</label>
          <Select
            className="filter-select"
            placeholder="Select operator"
            value={filter.operator || undefined}
            onChange={(value) => onUpdate(index, "operator", value)}
            showSearch={!isBooleanValue}
            filterOption={filterOption}
            options={operatorOptions}
            getPopupContainer={(trigger) => trigger.parentNode}
          />
        </div>
      )}
      <div className="filter-field filter-field-value">
        <label className="filter-label">{isDateValue ? "Date Range" : "Value"}</label>
        {isDateValue ? (
          <RangePicker
            className="filter-date-picker"
            format="DD/MM/YYYY"
            value={parseDateValue()}
            onChange={handleDateRangeChange}
            style={{ width: "100%" }}
          />
        ) : isDropdownValue ? (
          <Select
            className="filter-select"
            mode={isMultiSelect ? "multiple" : undefined}
            placeholder={isValueOptionsLoading ? "Loading values..." : "Select value"}
            loading={isValueOptionsLoading}
            value={
              isValueOptionsLoading
                ? undefined
                : isMultiSelect
                  ? toArrayValue(filter.value).map(resolveOptionValue)
                  : resolveOptionValue(filter.value)
            }
            onChange={(value) => onUpdate(index, "value", value)}
            onOpenChange={(open) => {
              if (open && selectedKeyConfig?.apiType) {
                onLoadValueOptions?.(selectedKeyConfig.apiType, {
                  force: optionsFailed || valueOptions.length === 0,
                });
              }
            }}
            showSearch
            filterOption={filterOption}
            options={[...valueOptions]
              .map((option) => ({
                ...option,
                label: String(option.label ?? option.value ?? ""),
                value: String(option.value ?? ""),
              }))
              .sort((a, b) =>
                selectedKeyConfig?.value === "salary_rate"
                  ? 0
                  : compareAlphaLabels(a.label, b.label)
              )}
            notFoundContent={
              isValueOptionsLoading ? (
                <div className="filter-options-loading">
                  <Spin size="small" />
                  <span>Loading values...</span>
                </div>
              ) : optionsFailed ? (
                <div className="filter-options-loading">Couldn’t load values. Open the list to retry.</div>
              ) : (
                "No data found"
              )
            }
            dropdownStyle={{ zIndex: 9999 }}
            popupClassName="filter-value-dropdown"
            maxTagCount="responsive"
            maxTagPlaceholder={renderOmittedTags}
            virtual={false}
          />
        ) : isMultiSelect && !isTextValue ? (
          <Select
            className="filter-select"
            mode="tags"
            placeholder="Enter value"
            value={toArrayValue(filter.value)}
            onChange={(value) => onUpdate(index, "value", value)}
            options={valueOptions}
            filterOption={filterOption}
            dropdownStyle={{ zIndex: 9999 }}
            maxTagCount="responsive"
            maxTagPlaceholder={renderOmittedTags}
            virtual={false}
          />
        ) : (
          <Input
            className="filter-input"
            placeholder="Enter value"
            value={Array.isArray(filter.value) ? filter.value.join(", ") : filter.value || ""}
            onChange={(e) => onUpdate(index, "value", e.target.value)}
          />
        )}
      </div>
      <Button
        type="text"
        className="filter-remove-btn"
        icon={<DeleteOutlined />}
        onClick={() => onRemove(index)}
      />
    </div>
  );
};

function CreateReport({
  onBack,
  onPreviewSuccess,
  initialConfig,
  onConfigChange,
  reportId,
  onSaved,
}) {
  const [reportTitle, setReportTitle] = useState(initialConfig?.reportTitle || "Untitled report");
  const [fieldSearch, setFieldSearch] = useState("");
  const [selectedFields, setSelectedFields] = useState(() =>
    (initialConfig?.selectedFields || []).map(getColumnKey).filter(Boolean)
  );
  const [filters, setFilters] = useState(initialConfig?.filters || []);
  const [dynamicOptions, setDynamicOptions] = useState({});
  const [filterOptionsStatus, setFilterOptionsStatus] = useState({});
  const onConfigChangeRef = useRef(onConfigChange);
  onConfigChangeRef.current = onConfigChange;
  const inflightFilterOptions = useRef({});
  const loadedFilterOptions = useRef({});
  const filterOptionsAlive = useRef(true);
  const fetchOptionsForApiTypeRef = useRef(null);

  const initialFieldsKey = (initialConfig?.selectedFields || [])
    .map(getColumnKey)
    .filter(Boolean)
    .join("\0");

  useEffect(() => {
    const nextFields = (initialConfig?.selectedFields || [])
      .map(getColumnKey)
      .filter(Boolean);
    setSelectedFields((prev) =>
      prev.join("\0") === nextFields.join("\0") ? prev : nextFields
    );
    if (initialConfig?.reportTitle) {
      setReportTitle(initialConfig.reportTitle);
    }
    if (initialConfig?.filters) {
      setFilters(initialConfig.filters);
    }
    // Only re-apply when the parent sends a different column order (e.g. back from preview).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialFieldsKey]);

  useEffect(() => {
    filterOptionsAlive.current = true;
    return () => {
      filterOptionsAlive.current = false;
    };
  }, []);

  const fetchTagOptions = async (type) => {
    const params = { limit: 20000, sort: "name", type };
    const response = await API_MANAGER.getTagsBySearch(params);
    const root = response?.data;
    const body = root?.data ?? root;
    const lists = [body?.tags, body?.suggestedTags, body, root?.tags, root?.suggestedTags];
    const tags = lists.find(
      (list) => Array.isArray(list) && list.length && typeof list[0] === "object"
    ) || [];
    const seen = new Set();
    const uniqueTags = tags.filter((tag) => {
      const id = String(tag?._id || tag?.id || tag?.name || "");
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
    return uniqueTags
      .map((e) => {
        const name = e?.name == null || e?.name === "" ? "" : String(e.name);
        const id = e?._id || e?.id || name;
        if (!name && !id) return null;
        if (NAME_VALUED_TAG_TYPES.includes(type)) {
          return { label: name || id, value: name || String(id) };
        }
        return { label: name || String(id), value: id };
      })
      .filter(Boolean);
  };

  const mergeNamedTagOptions = (optionLists) => {
    const seen = new Set();
    return optionLists
      .flat()
      .reduce((acc, option) => {
        const label = String(option?.label || "").trim();
        if (!label) return acc;
        const key = label.toLowerCase();
        if (seen.has(key)) return acc;
        seen.add(key);
        acc.push({ label, value: label });
        return acc;
      }, [])
      .sort((a, b) => a.label.localeCompare(b.label));
  };

  const fetchQualificationStateOptions = async () => {
    const [stateOptions, countryOptions] = await Promise.all([
      fetchTagOptions("STATE"),
      fetchTagOptions("COUNTRY"),
    ]);
    return mergeNamedTagOptions([stateOptions, countryOptions]);
  };

  const fetchLocationOptions = async () => {
    const response = await API_MANAGER.getCandidateLocations();
    const locations = response?.data?.data || [];
    return locations.map((e) => ({
      label: e?.name || e,
      value: e?.name || e,
    }));
  };

  const fetchLocationListOptions = async (type) => {
    const response = await API_MANAGER.getCandidateLocationsList(type);
    return buildLocationListOptions(extractLocationList(response, type), type);
  };

  const fetchCampaignOptions = async () => {
    const params = { search: "", sort: "-createdAt", limit: 20000, page: 1 };
    const response = await API_MANAGER.getSingleUserCampaignDetails(params);
    const campaigns = response?.data?.data || [];
    return campaigns.map((e) => ({
      label: e?.campaignName || e?.name,
      value: e?._id,
    }));
  };

  const fetchCampaignList = async () => {
    const params = { limit: 1000 };
    const isRoot = localStorage.getItem("user") === "Root";
    const response = isRoot
      ? await API_MANAGER.getCampaignListRoot(params)
      : await API_MANAGER.getCampaignList(params);
    const body = response?.data?.data;
    if (Array.isArray(body?.result)) return body.result;
    if (Array.isArray(body)) return body;
    return [];
  };

  const toUniqueTextOptions = (values) => {
    const seen = new Set();
    return values
      .map((value) => String(value ?? "").trim())
      .filter((value) => {
        if (!value) return false;
        const key = value.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .sort((a, b) => {
        const aNum = Number(a);
        const bNum = Number(b);
        if (!Number.isNaN(aNum) && !Number.isNaN(bNum)) return aNum - bNum;
        return a.localeCompare(b, undefined, { numeric: true });
      })
      .map((value) => ({ label: value, value }));
  };

  const fetchProjectCodeOptions = async () => {
    const campaigns = await fetchCampaignList();
    return toUniqueTextOptions(
      campaigns.map((campaign) => campaign?.projectCode ?? campaign?.project_code ?? "")
    );
  };

  const fetchAdvertTargetHeadcountOptions = async () => {
    const campaigns = await fetchCampaignList();
    return toUniqueTextOptions(
      campaigns.map(
        (campaign) =>
          campaign?.targetHeadCount ??
          campaign?.targetHeadcount ??
          campaign?.target_headcount ??
          ""
      )
    );
  };

  const formatSalaryNumber = (value) => {
    if (value === undefined || value === null || value === "") return "";
    const num = Number(value);
    if (Number.isNaN(num)) return String(value).trim();
    return Number.isInteger(num) ? String(num) : String(num);
  };

  const formatSalaryRange = (minSalary, maxSalary) => {
    const min = formatSalaryNumber(minSalary);
    const max = formatSalaryNumber(maxSalary || minSalary);
    if (!min) return "";
    return `$${min}-${max || min}`;
  };

  const extractCampaignsFromListResponse = (response) => {
    const body = response?.data?.data ?? response?.data;
    if (Array.isArray(body)) return body;
    if (Array.isArray(body?.result)) return body.result;
    if (Array.isArray(body?.data)) return body.data;
    return [];
  };

  const fetchSalaryRateOptions = async () => {
    const params = { limit: 1000 };
    let response;
    try {
      response = await API_MANAGER.getCampaignListRoot(params);
    } catch (error) {
      response = await API_MANAGER.getCampaignList(params);
    }
    const campaigns = extractCampaignsFromListResponse(response);
    const ranges = campaigns.flatMap((campaign) => {
      const adverts = Array.isArray(campaign?.adverts) ? campaign.adverts : [];
      return adverts.map((advert) =>
        formatSalaryRange(advert?.minSalary, advert?.maxSalary)
      );
    });
    return toUniqueTextOptions(ranges);
  };

  const fetchAdvertOptions = async () => {
    const params = { limit: 20000, page: 1 };
    const response = await API_MANAGER.getSingleUserCampaign(params);
    const adverts = response?.data?.data?.result || response?.data?.data || [];
    const seenIds = new Set();
    const options = adverts
      .filter((e) => {
        const id = e?._id || e?.id;
        if (!id || seenIds.has(id)) return false;
        seenIds.add(id);
        return true;
      })
      .map((e, index) => {
        const advertName =
          e?.jobTitle || e?.advertName || e?.name || e?.title || `Advert ${index + 1}`;
        const campaignName = extractCampaignName(e);
        return {
          label: campaignName ? `${advertName} - ${campaignName}` : advertName,
          name: advertName,
          value: e?._id || e?.id,
        };
      })
      .filter((opt) => opt.label && opt.value);
    return options;
  };

  const fetchUserOptions = async () => {
    const params = { search: "", sort: "-isActive" };
    const response = await API_MANAGER.getRecruiterUserList(params);
    const data = response?.data?.data || response?.data || [];
    if (!Array.isArray(data)) return [];
    return data
      .filter((e) => e?.user?.id)
      .map((e) => {
        const user = e.user;
        const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(" ").trim();
        return {
          label: fullName || user?.name || user?.email || user?.id,
          value: user?.id,
        };
      });
  };

  const LOCATION_LIST_API_TYPES = {
    LOCATION_CITY: "city",
    LOCATION_STATE: "state",
    LOCATION_COUNTRY: "country",
    LOCATION_POSTAL_CODE: "postalCode",
    LOCATION_STREET: "street",
  };

  const fetchOptionsForApiType = async (apiType) => {
    if (LOCATION_LIST_API_TYPES[apiType]) {
      return fetchLocationListOptions(LOCATION_LIST_API_TYPES[apiType]);
    }
    switch (apiType) {
      case "LOCATION":
        return fetchLocationOptions();
      case "CAMPAIGN":
        return fetchCampaignOptions();
      case "PROJECT_CODE":
        return fetchProjectCodeOptions();
      case "ADVERT_TARGET_HEADCOUNT":
        return fetchAdvertTargetHeadcountOptions();
      case "SALARY_RATE":
        return fetchSalaryRateOptions();
      case "ADVERT":
        return fetchAdvertOptions();
      case "USER":
        return fetchUserOptions();
      case "QUALIFICATION_STATE":
        return fetchQualificationStateOptions();
      default:
        return fetchTagOptions(apiType);
    }
  };
  fetchOptionsForApiTypeRef.current = fetchOptionsForApiType;

  const loadFilterOptions = useCallback(async (apiType, { force = false } = {}) => {
    if (!apiType) return;
    if (inflightFilterOptions.current[apiType]) return;
    if (!force && loadedFilterOptions.current[apiType]) return;

    inflightFilterOptions.current[apiType] = true;
    setFilterOptionsStatus((prev) => ({ ...prev, [apiType]: "loading" }));

    try {
      const options = await fetchOptionsForApiTypeRef.current(apiType);
      if (!filterOptionsAlive.current) return;
      loadedFilterOptions.current[apiType] = true;
      setDynamicOptions((prev) => ({ ...prev, [apiType]: options }));
      setFilterOptionsStatus((prev) => ({ ...prev, [apiType]: "success" }));
    } catch (error) {
      if (!filterOptionsAlive.current) return;
      loadedFilterOptions.current[apiType] = false;
      setFilterOptionsStatus((prev) => ({ ...prev, [apiType]: "error" }));
    } finally {
      inflightFilterOptions.current[apiType] = false;
    }
  }, []);

  useEffect(() => {
    const apiTypes = [
      ...new Set(
        filters
          .map(
            (filter) =>
              BASE_FILTER_KEY_OPTIONS.find((item) => item.value === filter.key)?.apiType
          )
          .filter(Boolean)
      ),
    ];
    apiTypes.forEach((apiType) => {
      loadFilterOptions(apiType);
    });
  }, [filters, loadFilterOptions]);

  useEffect(() => {
    onConfigChangeRef.current?.({
      reportTitle,
      selectedFields,
      filters,
    });
  }, [reportTitle, selectedFields, filters]);

  const filterKeyOptions = useMemo(() => {
    return BASE_FILTER_KEY_OPTIONS.map((item) => {
      const base = {
        ...item,
        multiSelect: MULTI_SELECT_FILTER_KEYS.includes(item.value),
      };
      const spaceOptionLabels = (options = []) =>
        options.map((opt) => ({
          ...opt,
          label: formatLabelSpacing(opt.label),
        }));
      if (item.staticOptions) {
        return { ...base, options: spaceOptionLabels(item.staticOptions) };
      }
      if (item.apiType && dynamicOptions[item.apiType]) {
        const options = dynamicOptions[item.apiType];
        if (item.value === "userName" || item.value === "auditTrailUser") {
          return {
            ...base,
            options: spaceOptionLabels(
              options.map((opt) => ({
                label: opt.label,
                value: opt.label,
              }))
            ),
          };
        }
        return { ...base, options: spaceOptionLabels(options) };
      }
      return { ...base, options: [] };
    }).sort((a, b) => compareAlphaLabels(a.label, b.label));
  }, [dynamicOptions]);

  const selectedFilterKeys = useMemo(
    () => filters.map((filter) => filter.key),
    [filters]
  );

  const addFilter = () => {
    if (selectedFilterKeys.filter(Boolean).length >= filterKeyOptions.length) {
      message.warning("All available filters have been added");
      return;
    }
    setFilters([...filters, { key: "", operator: "contains", value: "" }]);
  };

  const updateFilter = (index, field, value) => {
    if (
      field === "key" &&
      filters.some((filter, i) => i !== index && filter.key === value)
    ) {
      return;
    }
    const updatedFilters = [...filters];
    updatedFilters[index] = { ...updatedFilters[index], [field]: value };
    if (field === "key") {
      updatedFilters[index].value = "";
      const keyConfig = BASE_FILTER_KEY_OPTIONS.find((item) => item.value === value);
      if (isBooleanDropdownFilter(keyConfig)) {
        updatedFilters[index].operator = "contains";
      }
      if (keyConfig?.apiType) loadFilterOptions(keyConfig.apiType);
    }
    setFilters(updatedFilters);
  };

  const removeFilter = (index) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const buildFilters = () =>
    filters
      .filter((f) => f.key && (Array.isArray(f.value) ? f.value.length > 0 : f.value))
      .flatMap((f) => {
        const selectedKeyConfig = filterKeyOptions.find((k) => k.value === f.key);
        const isDateField = selectedKeyConfig?.valueType === "date";

        if (f.key === CANDIDATE_STATUS_FILTER_KEY) {
          return toArrayValue(f.value)
            .filter((status) => CANDIDATE_STATUS_PAYLOAD_KEYS.includes(status))
            .map((status) => ({
              key: status,
              operator: f.operator || "contains",
              value: ["yes"],
              labels: ["yes"],
            }));
        }

        if (f.key === "salary_rate") {
          const salaryValues = expandSalaryFilterValues(f.value);
          return {
            key: convertKeyToCamelCase(f.key),
            operator: f.operator || "contains",
            value: salaryValues,
            labels: salaryValues,
          };
        }

        let valueArray = [];
        let labelArray = [];
        if (isDateField && f.value) {
          try {
            const parsed = JSON.parse(f.value);
            valueArray = [parsed.startDate, parsed.endDate];
          } catch (e) {
            valueArray = [f.value];
          }
          labelArray = valueArray;
        } else {
          const rawValues = isTextFilterValue(selectedKeyConfig)
            ? splitCommaSeparatedValues(f.value)
            : Array.isArray(f.value)
              ? f.value
              : [f.value];
          const normalize = (list) => {
            const next = STATE_FILTER_KEYS.includes(f.key)
              ? list.map(extractStateFromLocation)
              : list;
            const lowered = next.map((v) => (typeof v === "string" ? v.toLowerCase() : v));
            if (f.key === "auditTrailStatus") {
              return lowered.map(normalizeAuditTrailStatusValue);
            }
            return lowered;
          };

          valueArray = normalize(rawValues);
          // advert_name labels must match the dropdown exactly: "Advert Name - Campaign Name"
          if (f.key === "advert_name") {
            labelArray = resolveValueNames(selectedKeyConfig, rawValues);
          } else {
            labelArray = normalize(resolveValueNames(selectedKeyConfig, rawValues));
          }
        }

        return {
          key: convertKeyToCamelCase(f.key),
          operator: isBooleanDropdownFilter(selectedKeyConfig)
            ? f.operator === "notContains"
              ? "notContains"
              : "contains"
            : f.operator || "contains",
          value: valueArray,
          labels: labelArray,
        };
      });

  const buildFilterSummary = () =>
    filters
      .filter((f) => f.key && (Array.isArray(f.value) ? f.value.length > 0 : f.value))
      .map((f) => {
        const keyConfig = filterKeyOptions.find((k) => k.value === f.key);
        const keyLabel = keyConfig?.label || getFieldLabel(f.key);

        if (keyConfig?.valueType === "date") {
          try {
            const parsed = JSON.parse(f.value);
            if (parsed?.startDate && parsed?.endDate) {
              return {
                key: f.key,
                keyLabel,
                operatorLabel: "Between",
                values: [
                  `${dayjs(parsed.startDate).format("DD/MM/YYYY")} - ${dayjs(
                    parsed.endDate
                  ).format("DD/MM/YYYY")}`,
                ],
              };
            }
          } catch (e) {
            // falls through to the plain value handling below
          }
        }

        const valueOptions = keyConfig?.options || [];
        const values = (isTextFilterValue(keyConfig)
          ? splitCommaSeparatedValues(f.value)
          : toArrayValue(f.value)
        ).map((item) => {
          const match = valueOptions.find(
            (option) => String(option.value).toLowerCase() === String(item).toLowerCase()
          );
          return match?.label ?? item;
        });

        return {
          key: f.key,
          keyLabel,
          operatorLabel:
            getOperatorOptions(keyConfig).find(
              (o) =>
                o.value ===
                (isBooleanDropdownFilter(keyConfig)
                  ? f.operator === "notContains"
                    ? "notContains"
                    : "contains"
                  : f.operator || "contains")
            )?.label ||
            "",
          values,
        };
      });

  const buildPayload = (format, doctype = null, columnsOverride = null) => {
    const columns = normalizeReportColumnIds(
      columnsOverride || selectedFields,
      ALL_FIELDS
    );
    const formattedFilters = buildFilters();

    const payload = {
      format,
      name: reportTitle || "Untitled report",
      columns,
    };

    if (formattedFilters.length > 0) {
      payload.filters = formattedFilters;
    }

    if (doctype) {
      payload.doctype = doctype;
    }

    return payload;
  };

  const [exportLoading, setExportLoading] = useState(false);
  const exportWaitRef = useRef(false);

  useEffect(() => {
    ensureSocketConnected();

    const clearExportWait = () => {
      exportWaitRef.current = false;
      setExportLoading(false);
    };

    window.addEventListener("cinchy-report-export-downloaded", clearExportWait);
    window.addEventListener("cinchy-report-export-failed", clearExportWait);
    return () => {
      window.removeEventListener("cinchy-report-export-downloaded", clearExportWait);
      window.removeEventListener("cinchy-report-export-failed", clearExportWait);
    };
  }, []);
  const [saveLoading, setSaveLoading] = useState(false);
  const [pdfLimitModal, setPdfLimitModal] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const handlePreview = () => {
    if (selectedFields.length === 0) {
      message.warning("Please select at least one column");
      return;
    }
    const payload = buildPayload("preview");
    if (onPreviewSuccess) {
      onPreviewSuccess([], {
        reportTitle,
        selectedFields,
        previewColumns: [],
        filters,
        filterPayload: payload.filters || [],
        filterSummary: buildFilterSummary(),
        loadOnMount: true,
      });
    }
  };

  const handleSaveReport = async () => {
    if (selectedFields.length === 0) {
      message.warning("Please select at least one column");
      return;
    }

    const formattedFilters = buildFilters();
    const payload = {
      name: reportTitle || "Untitled report",
      cols: normalizeReportColumnIds(selectedFields, ALL_FIELDS),
      filters: formattedFilters,
    };

    setSaveLoading(true);
    try {
      if (reportId) {
        await API_MANAGER.updateReport(reportId, payload);
        message.success("Report successfully updated.");
      } else {
        const response = await API_MANAGER.saveReport(payload);
        const body = response?.data?.data;
        const saved = body?.data || body?.report || body;
        if (onSaved) onSaved(saved?._id || saved?.id);
        message.success("Report successfully updated.");
      }
    } catch (error) {
      showReportError(error, "Failed to save report");
    }
    setSaveLoading(false);
  };

  const handleExport = async (doctype, columnsOverride = null) => {
    if (selectedFields.length === 0) {
      message.warning("Please select at least one column");
      return;
    }
    if (exportWaitRef.current) return;

    const payload = buildPayload("export", doctype, columnsOverride);
    setExportLoading(doctype);
    exportWaitRef.current = true;

    try {
      await requestReportDownload(() => API_MANAGER.generateReport(payload), {
        fileType: doctype,
        onResponse: (_response, meta) => {
          exportWaitRef.current = false;
          setExportLoading(false);
          if (meta?.background) {
            message.success(
              "Your export is being processed and will download automatically once ready."
            );
          }
        },
      });
    } catch (error) {
      if (error?.response) {
        showReportError(error, "Failed to export report");
      } else {
        message.error(error?.message || "Could not connect. Please try the download again.");
      }
    } finally {
      exportWaitRef.current = false;
      setExportLoading(false);
    }
  };

  const requestPdfExport = () => {
    if (selectedFields.length === 0) {
      message.warning("Please select at least one column");
      return;
    }
    if (getExportColumnCount(selectedFields) > PDF_COLUMN_LIMIT) {
      setPdfLimitModal("pdf");
      return;
    }
    handleExport("pdf");
  };

  const exportMenuItems = [
    {
      key: "pdf",
      label: (
        <div className="export-menu-item">
          <FilePdfOutlined className="export-menu-icon pdf" />
          <span>Export as PDF</span>
        </div>
      ),
      onClick: requestPdfExport,
    },
    {
      key: "csv",
      label: (
        <div className="export-menu-item">
          <FileTextOutlined className="export-menu-icon csv" />
          <span>Export as CSV</span>
        </div>
      ),
      onClick: () => handleExport("xlsx"),
    },
  ];

  const filteredGroups = useMemo(() => {
    const query = fieldSearch.trim().toLowerCase();
    if (!query) return FIELD_GROUPS;

    return FIELD_GROUPS.map((group) => ({
      ...group,
      fields: group.fields.filter((field) =>
        matchesReportSearch(fieldSearch, field.label, group.category, field.badge)
      ),
    })).filter((group) => group.fields.length > 0);
  }, [fieldSearch]);

  const hasSelectedColumns = selectedFields.length > 0;

  const toggleField = (fieldId) => {
    setSelectedFields((prev) =>
      prev.includes(fieldId)
        ? prev.filter((id) => id !== fieldId)
        : [...prev, fieldId]
    );
    setShowPreview(false);
    setPreviewData(null);
  };

  const toggleGroupFields = (groupFields, selectAll) => {
    const groupIds = groupFields.map((field) => field.id);
    setSelectedFields((prev) =>
      selectAll
        ? [...prev, ...groupIds.filter((id) => !prev.includes(id))]
        : prev.filter((id) => !groupIds.includes(id))
    );
    setShowPreview(false);
    setPreviewData(null);
  };

  const removeField = (fieldId) => {
    setSelectedFields((prev) => prev.filter((id) => id !== fieldId));
    setShowPreview(false);
    setPreviewData(null);
  };

  const [draggedIndex, setDraggedIndex] = useState(null);
  const [draggedFieldId, setDraggedFieldId] = useState(null);
  const [dropIndex, setDropIndex] = useState(null);
  const [isDropActive, setIsDropActive] = useState(false);
  const draggedIndexRef = useRef(null);
  const draggedFieldIdRef = useRef(null);
  const dropIndexRef = useRef(null);

  const setDropIndexIfChanged = (next) => {
    if (dropIndexRef.current === next) return;
    dropIndexRef.current = next;
    setDropIndex(next);
  };

  const handleDragStart = (e, index) => {
    draggedIndexRef.current = index;
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", String(index));
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = draggedFieldIdRef.current ? "copy" : "move";
    const rect = e.currentTarget.getBoundingClientRect();
    const insertAfter = e.clientX > rect.left + rect.width / 2;
    setDropIndexIfChanged(insertAfter ? index + 1 : index);
  };

  const reorderSelectedFields = (from, insertAt) => {
    if (from === null || from === undefined || insertAt === null || insertAt === undefined) {
      return;
    }
    setSelectedFields((prev) => {
      if (from < 0 || from >= prev.length) return prev;
      let to = insertAt;
      if (to > from) to -= 1;
      if (to === from || to < 0 || to > prev.length) return prev;
      const next = [...prev];
      const [item] = next.splice(from, 1);
      next.splice(to, 0, item);
      return next;
    });
  };

  const resetColumnDrag = () => {
    draggedIndexRef.current = null;
    dropIndexRef.current = null;
    setDraggedIndex(null);
    setDropIndex(null);
  };

  const handleDragEnd = () => {
    resetColumnDrag();
  };

  const clearFieldDrag = () => {
    draggedFieldIdRef.current = null;
    dropIndexRef.current = null;
    setDraggedFieldId(null);
    setDropIndex(null);
    setIsDropActive(false);
  };

  const handleFieldDragStart = (e, fieldId) => {
    draggedFieldIdRef.current = fieldId;
    setDraggedFieldId(fieldId);
    e.dataTransfer.effectAllowed = "copy";
    e.dataTransfer.setData("text/plain", fieldId);
  };

  const handlePreviewDragOver = (e) => {
    if (!draggedFieldIdRef.current && draggedIndexRef.current === null) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = draggedFieldIdRef.current ? "copy" : "move";
    if (draggedFieldIdRef.current) {
      setIsDropActive((prev) => prev || true);
      const overColumn =
        typeof e.target.closest === "function" &&
        e.target.closest(".table-header-column, .header-column");
      if (!overColumn) {
        setDropIndexIfChanged(null);
      }
    }
  };

  const handlePreviewDragLeave = (e) => {
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setIsDropActive(false);
    setDropIndexIfChanged(null);
  };

  const handlePreviewDrop = (e) => {
    e.preventDefault();

    if (draggedFieldIdRef.current) {
      const fieldId = draggedFieldIdRef.current;
      const insertAt = dropIndexRef.current;
      setSelectedFields((prev) => {
        if (prev.includes(fieldId)) return prev;
        const next = [...prev];
        next.splice(insertAt === null ? next.length : insertAt, 0, fieldId);
        return next;
      });
      setShowPreview(false);
      setPreviewData(null);
      clearFieldDrag();
      return;
    }

    if (draggedIndexRef.current !== null) {
      reorderSelectedFields(draggedIndexRef.current, dropIndexRef.current);
      resetColumnDrag();
    }
  };

  const handleColumnDrop = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const insertAfter = e.clientX > rect.left + rect.width / 2;
    const insertAt = insertAfter ? index + 1 : index;

    if (draggedFieldIdRef.current) {
      dropIndexRef.current = insertAt;
      handlePreviewDrop(e);
      return;
    }

    reorderSelectedFields(draggedIndexRef.current, insertAt);
    resetColumnDrag();
  };

  const getColumnDropClass = (index) => {
    if (dropIndex === null) return "";
    if (draggedIndex !== null && (dropIndex === draggedIndex || dropIndex === draggedIndex + 1)) {
      return "";
    }
    if (dropIndex === index) return "drop-before";
    if (dropIndex === selectedFields.length && index === selectedFields.length - 1) {
      return "drop-after";
    }
    return "";
  };

  return (
    <div className="create-report-workspace">
      <aside className="available-fields-panel">
        <div className="fields-panel-header">
          <div className="fields-title-row">
            <h3 className="fields-title">Available Fields</h3>
          
          </div>
          <p className="fields-subtitle">
          Drag or click fields, to build your report.
          </p>
          <Input
            className="fields-search"
            placeholder="Search Job Advert"
            prefix={<img src={SearchBlueIcon} alt="" className="fields-search-icon" />}
            value={fieldSearch}
            onChange={(e) => setFieldSearch(e.target.value)}
            allowClear
          />
        </div>

        <div className="fields-list">
          {filteredGroups.map((group) => {
            const groupSelectedCount = group.fields.filter((field) =>
              selectedFields.includes(field.id)
            ).length;
            const allGroupSelected = groupSelectedCount === group.fields.length;

            return (
            <div className="field-group" key={group.category}>
              <div className="field-group-header">
                <p className="field-group-title">{group.category}</p>
                <Checkbox
                  className="field-group-select-all"
                  checked={allGroupSelected}
                  indeterminate={groupSelectedCount > 0 && !allGroupSelected}
                  onChange={(e) => toggleGroupFields(group.fields, e.target.checked)}
                >
                  Select all
                </Checkbox>
              </div>
              <div className="field-group-items">
                {group.fields.map((field) => {
                  const checked = selectedFields.includes(field.id);
                  return (
                    <div
                      role="button"
                      tabIndex={0}
                      key={field.id}
                      className={`field-item ${checked ? "selected" : ""} ${
                        draggedFieldId === field.id ? "dragging" : ""
                      }`}
                      draggable
                      onDragStart={(e) => handleFieldDragStart(e, field.id)}
                      onDragEnd={clearFieldDrag}
                      onClick={() => toggleField(field.id)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          toggleField(field.id);
                        }
                      }}
                    >
                      <div className="field-item-left">
                        <HolderOutlined className="field-drag-handle" />
                        <span className="field-label" title={field.label}>{field.label}</span>
                      </div>
                      <Checkbox
                        checked={checked}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => toggleField(field.id)}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            );
          })}
        </div>
      </aside>

      <div className="report-preview-panel">
        <div className="preview-header">
          <div className="preview-title-block">
            <div className="preview-title-row">
              <Tooltip title="Click to rename" placement="top">
                <span className="report-title-input-wrap">
                  <Input
                    className="report-title-input"
                    value={reportTitle}
                    onChange={(e) => setReportTitle(e.target.value)}
                    onFocus={(e) => {
                      if (reportTitle.trim() === "Untitled report") {
                        setReportTitle("");
                        return;
                      }
                      e.target.select();
                    }}
                    bordered={false}
                    placeholder={REPORT_TITLE_PLACEHOLDER}
                  />
                </span>
              </Tooltip>
            </div>
            <p className="preview-subtitle">
              Choose your columns, reorder and filter the data. The table will
              update in real time!
            </p>
          </div>
          <div className="preview-actions">
            <button
              type="button"
              className={`action-btn ${!hasSelectedColumns ? "disabled" : ""}`}
              disabled={!hasSelectedColumns || saveLoading}
              onClick={handleSaveReport}
            >
              <img src={SaveIcon} alt="" />
              <span>
                {saveLoading
                  ? "Saving..."
                  : reportId
                  ? "Update Report"
                  : "Save Report"}
              </span>
            </button>
            <button
              type="button"
              className={`action-btn ${!hasSelectedColumns ? "disabled" : ""}`}
              disabled={!hasSelectedColumns}
              onClick={handlePreview}
            >
              <img src={PreviewIcon} alt="" />
              <span>Preview</span>
            </button>
            <Dropdown
              menu={{ items: exportMenuItems }}
              trigger={["click"]}
              placement="bottomRight"
              disabled={!hasSelectedColumns || exportLoading}
              overlayClassName="export-dropdown-menu"
            >
              <button
                type="button"
                className={`action-btn export-btn ${!hasSelectedColumns ? "disabled" : ""}`}
                disabled={!hasSelectedColumns || exportLoading}
              >
                <img
                  src={hasSelectedColumns ? DownloadIconWhite : DownloadIcon}
                  alt=""
                />
                <span>{exportLoading ? "Exporting..." : "Export"}</span>
                <img
                  src={hasSelectedColumns ? ChevronDownWhiteIcon : ChevronDownIcon}
                  alt=""
                  className="chevron-icon"
                />
              </button>
            </Dropdown>
          </div>
        </div>

        <div className="filters-card">
          <div className="filters-header">
            <p className="section-label">Filters</p>
            <button type="button" className="add-filter-btn" onClick={addFilter}>
              <img src={PlusFilterIcon} alt="" />
              <span>Add filter</span>
            </button>
          </div>
          {filters.length > 0 && (
            <div className="filters-list">
              {filters.map((filter, index) => {
                const apiType = BASE_FILTER_KEY_OPTIONS.find(
                  (item) => item.value === filter.key
                )?.apiType;
                const status = apiType ? filterOptionsStatus[apiType] : undefined;
                return (
                <FilterRow
                  key={index}
                  filter={filter}
                  index={index}
                  onUpdate={updateFilter}
                  onRemove={removeFilter}
                  filterKeyOptions={filterKeyOptions}
                  usedKeys={selectedFilterKeys}
                  optionsLoading={Boolean(apiType) && status !== "success" && status !== "error"}
                  optionsFailed={status === "error"}
                  onLoadValueOptions={loadFilterOptions}
                />
                );
              })}
            </div>
          )}
        </div>

        <p className="section-label preview-section-label">Report Preview</p>
        
        {showPreview && previewData && previewData.length > 0 ? (
          <div
            className={`preview-data-table ${isDropActive ? "drop-active" : ""}`}
            onDragOver={handlePreviewDragOver}
            onDragLeave={handlePreviewDragLeave}
            onDrop={handlePreviewDrop}
          >
            <div className="preview-table-header">
              {selectedFields.map((fieldId, index) => {
                return (
                  <div
                    key={fieldId}
                    className={`header-column ${
                      draggedIndex === index ? "dragging" : ""
                    } ${getColumnDropClass(index)}`}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={(e) => handleDragOver(e, index)}
                    onDrop={(e) => handleColumnDrop(e, index)}
                    onDragEnd={handleDragEnd}
                  >
                    <HolderOutlined className="drag-icon" />
                    <span className="header-label">{getFieldLabel(fieldId)}</span>
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => removeField(fieldId)}
                    >
                      <CloseOutlined />
                    </button>
                  </div>
                );
              })}
            </div>
            <div className="preview-table-body">
              {previewData.map((row, rowIndex) => (
                <div key={rowIndex} className="preview-table-row">
                  {selectedFields.map((fieldId) => {
                    const rawValue = row[fieldId];
                    const formattedValue =
                      typeof rawValue === "string"
                        ? formatPreviewDateValue(rawValue, fieldId)
                        : rawValue;
                    const value = formattedValue || "-";
                    const isNameField = fieldId === "firstName" || fieldId === "lastName" || fieldId === "candidateName";
                    const isGatesField = isGatesPreviewField(fieldId);
                    const trafficLight =
                      !isGatesField && !COMPLIANCE_STATUS_FIELDS.includes(fieldId)
                        ? renderYesNoTrafficLight(rawValue)
                        : null;
                    const listItems = getCellListItems(fieldId, rawValue);
                    return (
                      <div
                        key={fieldId}
                        className={`${isNameField ? "cell-name" : "cell-text"}${
                          isGatesField ? " cell-gates" : ""
                        } ${getAcceptRejectActionClass(row, fieldId)}`.trim()}
                      >
                        {isGatesField ? (
                          <GatesPreviewCell value={rawValue} />
                        ) : (
                          trafficLight ||
                          (listItems.length >= 1
                            ? renderBulletList(listItems)
                            : typeof value === "object"
                              ? JSON.stringify(value)
                              : value)
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
            {previewData.length === 0 && (
              <div className="preview-empty">No data found for the selected filters</div>
            )}
          </div>
        ) : (
          <div
            className={`preview-card ${hasSelectedColumns ? "has-columns" : ""} ${
              isDropActive ? "drop-active" : ""
            }`}
            onDragOver={handlePreviewDragOver}
            onDragLeave={handlePreviewDragLeave}
            onDrop={handlePreviewDrop}
          >
            {hasSelectedColumns ? (
              <div className="table-header-preview">
                {selectedFields.map((fieldId, index) => {
                  return (
                    <div
                      key={fieldId}
                      className={`table-header-column ${
                        draggedIndex === index ? "dragging" : ""
                      } ${getColumnDropClass(index)}`}
                      draggable
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragOver={(e) => handleDragOver(e, index)}
                      onDrop={(e) => handleColumnDrop(e, index)}
                      onDragEnd={handleDragEnd}
                    >
                      <HolderOutlined className="drag-handle" />
                      <span className="column-label">{getFieldLabel(fieldId)}</span>
                      <button
                        type="button"
                        className="remove-column-btn"
                        onClick={() => removeField(fieldId)}
                      >
                        <CloseOutlined />
                      </button>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="preview-placeholder">
                {isDropActive
                  ? "Drop here to add this column"
                  : "Drag or select the columns you need"}
              </p>
            )}
          </div>
        )}
      </div>

      <PdfColumnLimitModal
        open={Boolean(pdfLimitModal)}
        showColumnLimitNotice={
          pdfLimitModal === "pdf" &&
          getExportColumnCount(selectedFields) > PDF_COLUMN_LIMIT
        }
        showExcelOption={pdfLimitModal === "pdf"}
        onCancel={() => setPdfLimitModal(false)}
        onDownloadCsv={() => {
          setPdfLimitModal(false);
          handleExport("xlsx");
        }}
        onProceed={() => {
          const doctype = pdfLimitModal === "xlsx" ? "xlsx" : "pdf";
          const overPdfLimit =
            doctype === "pdf" &&
            getExportColumnCount(selectedFields) > PDF_COLUMN_LIMIT;
          setPdfLimitModal(false);
          handleExport(
            doctype,
            overPdfLimit
              ? sliceFieldsToExportColumnLimit(selectedFields, PDF_COLUMN_LIMIT)
              : null
          );
        }}
      />
      {(exportLoading === "xlsx" || exportLoading === "pdf") && (
        <div className="report-export-loader" role="status" aria-live="polite">
          <Spin size="large" />
          <p>
            {exportLoading === "pdf"
              ? "Preparing your PDF file"
              : "Preparing your Excel file"}
          </p>
        </div>
      )}
    </div>
  );
}

export default CreateReport;
